<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AppSearchBar',
  props: {
    advancedSearch: Object,
  },
  data: () => ({
    selection: 0,
    searchItem: '',
    search: null,
  }),
  computed: {
    ...mapState('auth', [
      'location',
      'settings',
    ]),
    ...mapState('users', [
      'searchSuggestions',
      'searchedUsers',
    ]),
    getLogo() {
      return this.settings && this.settings.base_options && this.settings.base_options.show_company_logo && this.location && this.location.image ?
        this.location.image :
        this.customerConfig.images.logo
    },
  },
  watch: {
    search() {
      const applicationMainEle = document.querySelector('.v-application--wrap')
      const darkLayer = document.querySelector('.v-application--wrap .dark-layer')

      if (this.search) {
        if (!darkLayer) {
          const ele = document.createElement('div')
          ele.classList.add('dark-layer')
          applicationMainEle && applicationMainEle.append(ele)
        }
      } else {
        applicationMainEle && applicationMainEle.removeChild(darkLayer)
      }
      this.getSuggestions(this.selection)
    },
  },
  methods: {
    ...mapActions('users', [
      'getSearchSuggestions',
      'getUsersBasedOnSuggestions',
    ]),
    getSuggestions(selectedFieldId) {
      const payload = {
        field_id: selectedFieldId,
        query: this.search,
      }
      this.getSearchSuggestions(payload)
    },
    onSearch() {
      if (!this.search) return false
      if (this.selection === 0) {
        if (this.$route.name === 'search-results' && this.$route.query.q !== this.search) {
          this.$router.push({ query: { q: this.search } })
        } else if (this.$route.query.q !== this.search) {
          this.$router.push({ name: 'search-results', query: { q: this.search } })
        }
      } else if (this.$route.name === 'who-is-who' && (this.$route.query.q !== this.search || this.$route.query.field_id !== this.selection)) {
        this.$router.push({ query: { q: this.search, field_id: this.selection, type: 'extendedSearch' } })
      } else if (this.$route.query.q !== this.search || this.$route.query.field_id !== this.selection) {
        this.$router.push({ name: 'who-is-who', query: { q: this.search, field_id: this.selection, type: 'extendedSearch' } })
      }
      this.search = null
    },
    closeSearchResultsList() {
      this.search = null
    },
  },
}
</script>
